module.exports = __webpack_public_path__ + "trinidad_tobago.2da9c0723ba637094249bbd8084a208b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trinidad_tobago.svg
// module id = 1161
// module chunks = 0